import React, { useState } from "react"
import SearchUGCForm from "./SearchUgc"
import { Button } from "@material-ui/core"
import Add from "@material-ui/icons/Add"
import Delete from "@material-ui/icons/Delete"
import { useTheme } from "@material-ui/core/styles"

export default function UserRightTable({ translate, rights, handleRights, }) {
    const { theme: { bgColors, colors } } = useTheme()
    const [tmpListRight, setTmpListRight] = useState([[0], [0], [0]])

    const deleteRight = (index) => {
        const newT = [...rights]
        newT.splice(index, 1)
        handleRights(newT)
    }

    const addRight = (right, type) => {
        let newListRight = [...tmpListRight]
        if (right !== false) {
            newListRight[type] = right
        } else {
            newListRight[type] = [0]
        }
        setTmpListRight(newListRight)
    }

    const handleButtonAddRight = () => {
        const reducedList = tmpListRight.reduce(((previousValue, currentValue) => previousValue + currentValue[0]), 0)
        if (reducedList > 0 && rights.findIndex(value => JSON.stringify(value) === JSON.stringify(tmpListRight)) === -1) {
            const newT = [...tmpListRight]
            handleRights([...rights, newT])
        }
    }

    return (
        <table className="table table-bordered table-striped table-sm">
            <thead className="table-dark">
                <tr>
                    <th className="font-smaller text-center" key='user'>{translate('user')}</th>
                    <th className="font-smaller text-center" key='group'>{translate('group')}</th>
                    <th className="font-smaller text-center" key='company'>{translate('company')}</th>
                    <th className="font-smaller text-center" key='_edit_'>{translate('edit')}</th>
                </tr>
            </thead>
            <tbody>
                {rights.map((value, index) =>
                    <tr key={index} className="text-center">
                        <td key='0' style={{color: colors.colorText}}
                            className={"font-smaller " + ((value[0] && value[0][0] > 0) && 'font-weight-bold')}>{(value[0] && value[0][0] > 0) ? value[0][1] : '-'}</td>
                        <td key='1' style={{color: colors.colorText}}
                            className={"font-smaller " + ((value[1] && value[1][0] > 0) && 'font-weight-bold')}>{(value[1] && value[1][0] > 0) ? value[1][1] : '-'}</td>
                        <td key='2' style={{color: colors.colorText}}
                            className={"font-smaller " + ((value[2] && value[2][0] > 0) && 'font-weight-bold')}>{(value[2] && value[2][0] > 0) ? value[2][1] : '-'}</td>
                        <td key={"_edit_"} className="font-smaller">
                            <Button variant="contained"  size="small"
                                style={{ padding: '4px', minWidth: '30px', backgroundColor: bgColors.bgDeleteBtn,
                  color: colors.colorPrimary0 }}
                                
                                onClick={() => deleteRight(index)}>
                                <Delete fontSize="small" />
                            </Button>
                        </td>
                    </tr>
                )}
                <tr>
                    <td >
                        <SearchUGCForm
                            ugc={0}
                            translate={translate}
                            addRight={(right) => addRight(right, 0)}
                        />
                    </td>
                    <td>
                        <SearchUGCForm
                            ugc={1}
                            translate={translate}
                            addRight={(right) => addRight(right, 1)}
                        />
                    </td>
                    <td>
                        <SearchUGCForm
                            ugc={2}
                            translate={translate}
                            addRight={(right) => addRight(right, 2)}
                        />
                    </td>
                    <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60px'}}>
                        <Button variant="contained" size="small" aria-label={translate('Add')}
                            style={{ padding: '4px', minWidth: '30px', backgroundColor: bgColors.bgEditBtn, color: colors.colorPrimary0}}
                            onClick={() => handleButtonAddRight()}>
                            <Add fontSize="small" />
                        </Button>
                    </td>
                </tr>
            </tbody>

        </table>
    )
}